import baseApi from '../baseApi';
import { SD_SPNameList } from '../../Utility/StaticDatas';

const baseUrl = `/AuthDataGet/ExecuteJson/${SD_SPNameList.DB_SP_TblClientRoutes}`;

const SPClientRoutesApi = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getClientRoutes: builder.query({
      query: () => ({
        url: `${baseUrl}/1`,
        method: 'POST',
        body: {},
      }),
      providesTags: ['ClientRouteApi'],
    }),
    getClientPage: builder.query({
      query: (data: string) => ({
        url: `${baseUrl}/2`,
        method: 'POST',
        body: { data },
      }),
      providesTags: ['ClientRouteApi'],
    }),
  }),
});

export const { useGetClientRoutesQuery, useGetClientPageQuery } =
  SPClientRoutesApi;

export default SPClientRoutesApi;
